import { Component, OnInit, ViewChild } from '@angular/core';
import { FirebaseListObservable } from 'angularfire2/database';
import { DatabaseService } from '../../database.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  providers: [DatabaseService]
})
export class MapComponent implements OnInit {
  entries = [];
  entryClients = [];
  lat = 45.5396;
  lng = -122.5921;
  radius = 100;
  points: Array<any> = [
    {lat: 45.4545, lng: -122.345, moles: 4},
    {lat: 45.495, lng: -122.395, moles: 2},
  ];
  area = [
     {
        "lng":-122.41071,
        "lat":45.56763
     },
     {
        "lng":-122.39652,
        "lat":45.57276
     },
     {
        "lng":-122.38327,
        "lat":45.57558
     },
     {
        "lng":-122.35062,
        "lat":45.56727
     },
     {
        "lng":-122.34104,
        "lat":45.55774
     },
     {
        "lng":-122.33662,
        "lat":45.55333
     },
     {
        "lng":-122.32202,
        "lat":45.54699
     },
     {
        "lng":-122.2949,
        "lat":45.54354
     },
     {
        "lng":-122.26074,
        "lat":45.4615
     },
     {
        "lng":-122.26074,
        "lat":45.4615
     },
     {
        "lng":-122.2556308777244,
        "lat":45.3878674080846744
     },
     {
        "lng":-122.35656776737284,
        "lat":45.348792977430528
     },
     {
        "lng":-122.57354774784159,
        "lat":45.320797171361442
     },
     {
        "lng":-122.64152565311502,
        "lat":45.335038147048456
     },
     {
        "lng":-122.65560188602518,
        "lat":45.334314116038506
     },
     {
        "lng":-122.66315498661112,
        "lat":45.317417431203473
     },
     {
        "lng":-122.66521492313456,
        "lat":45.305586753080124
     },
     {
        "lng":-122.65972175907206,
        "lat":45.29616873406245
     },
     {
        "lng":-122.66384163211893,
        "lat":45.28457517840834
     },
     {
        "lng":-122.68238106082987,
        "lat":45.293029046737116
     },
     {
        "lng":-122.68753090213846,
        "lat":45.2995497413997448
     },
     {
        "lng":-122.6950840027244,
        "lat":45.3000327259909749
     },
     {
        "lng":-122.7008056640625,
        "lat":45.29541858082882
     },
     {
        "lng":-122.71808662723612,
        "lat":45.299066752694255
     },
     {
        "lng":-122.7448658020408,
        "lat":45.301240169469323
     },
     {
        "lng":-122.7664951355369,
        "lat":45.2918214284037
     },
     {
        "lng":-122.81446530291242,
        "lat":45.282010898886174
     },
     {
        "lng":-122.83437802263899,
        "lat":45.27548818760818
     },
     {
        "lng":-122.84972,
        "lat":45.25965
     },
     {
        "lng":-122.85004,
        "lat":45.25965
     },
     {
        "lng":-122.85138,
        "lat":45.25964
     },
     {
        "lng":-122.85154,
        "lat":45.25964
     },
     {
        "lng":-122.85561,
        "lat":45.25963
     },
     {
        "lng":-122.85664,
        "lat":45.25962
     },
     {
        "lng":-122.86596,
        "lat":45.25962
     },
     {
        "lng":-122.86782,
        "lat":45.25958
     },
     {
        "lng":-122.86788,
        "lat":45.26387
     },
     {
        "lng":-122.8681,
        "lat":45.27436
     },
     {
        "lng":-122.86802,
        "lat":45.27676
     },
     {
        "lng":-122.86798,
        "lat":45.27837
     },
     {
        "lng":-122.86793,
        "lat":45.28006
     },
     {
        "lng":-122.86793,
        "lat":45.28185
     },
     {
        "lng":-122.8679,
        "lat":45.28325
     },
     {
        "lng":-122.86794,
        "lat":45.28501
     },
     {
        "lng":-122.86802,
        "lat":45.28659
     },
     {
        "lng":-122.8681,
        "lat":45.28734
     },
     {
        "lng":-122.868,
        "lat":45.29951
     },
     {
        "lng":-122.86798,
        "lat":45.30007
     },
     {
        "lng":-122.86797,
        "lat":45.30075
     },
     {
        "lng":-122.86793,
        "lat":45.30231
     },
     {
        "lng":-122.86793,
        "lat":45.30525
     },
     {
        "lng":-122.86795,
        "lat":45.30907
     },
     {
        "lng":-122.86799,
        "lat":45.31411
     },
     {
        "lng":-122.868,
        "lat":45.31555
     },
     {
        "lng":-122.86801,
        "lat":45.31703
     },
     {
        "lng":-122.86801,
        "lat":45.31738
     },
     {
        "lng":-122.86801,
        "lat":45.31738
     },
     {
        "lng":-122.86904,
        "lat":45.31736
     },
     {
        "lng":-122.899,
        "lat":45.31732
     },
     {
        "lng":-122.90888,
        "lat":45.32382
     },
     {
        "lng":-122.90938,
        "lat":45.34619
     },
     {
        "lng":-122.92881,
        "lat":45.34629
     },
     {
        "lng":-122.93996,
        "lat":45.34636
     },
     {
        "lng":-122.9578,
        "lat":45.34634
     },
     {
        "lng":-122.87308,
        "lat":45.60634
     },
     {
        "lng":-122.87308,
        "lat":45.60634
     },
     {
        "lng":-122.89151,
        "lat":45.62064
     },
     {
        "lng":-122.90877,
        "lat":45.63029
     },
     {
        "lng":-122.92911,
        "lat":45.63608
     },
     {
        "lng":-122.92877,
        "lat":45.67203
     },
     {
        "lng":-122.92896,
        "lat":45.72144
     },
     {
        "lng":-122.92897,
        "lat":45.72233
     },
     {
        "lng":-122.92781,
        "lat":45.72233
     },
     {
        "lng":-122.90248,
        "lat":45.72217
     },
     {
        "lng":-122.89633,
        "lat":45.72126
     },
     {
        "lng":-122.89471,
        "lat":45.72127
     },
     {
        "lng":-122.89436,
        "lat":45.72127
     },
     {
        "lng":-122.89011,
        "lat":45.7213
     },
     {
        "lng":-122.88622,
        "lat":45.72133
     },
     {
        "lng":-122.88495,
        "lat":45.72126
     },
     {
        "lng":-122.88239,
        "lat":45.72135
     },
     {
        "lng":-122.88161,
        "lat":45.72137
     },
     {
        "lng":-122.87473,
        "lat":45.72188
     },
     {
        "lng":-122.86725,
        "lat":45.72179
     },
     {
        "lng":-122.86366,
        "lat":45.72177
     },
     {
        "lng":-122.86175,
        "lat":45.72176
     },
     {
        "lng":-122.85854,
        "lat":45.72174
     },
     {
        "lng":-122.8434,
        "lat":45.72163
     },
     {
        "lng":-122.83299,
        "lat":45.72155
     },
     {
        "lng":-122.83243,
        "lat":45.72154
     },
     {
        "lng":-122.83091,
        "lat":45.72152
     },
     {
        "lng":-122.82621,
        "lat":45.7215
     },
     {
        "lng":-122.81593,
        "lat":45.72142
     },
     {
        "lng":-122.80419,
        "lat":45.7213
     },
     {
        "lng":-122.79305,
        "lat":45.72118
     },
     {
        "lng":-122.7848,
        "lat":45.72158
     },
     {
        "lng":-122.78207,
        "lat":45.72857
     },
     {
        "lng":-122.76671,
        "lat":45.72814
     },
     {
        "lng":-122.76261,
        "lat":45.72824
     },
     {
        "lng":-122.76261,
        "lat":45.72824
     },
     {
        "lng":-122.76211,
        "lat":45.72948
     },
     {
        "lng":-122.7606,
        "lat":45.7332
     },
     {
        "lng":-122.76011,
        "lat":45.73441
     },
     {
        "lng":-122.76011,
        "lat":45.73445
     },
     {
        "lng":-122.76028,
        "lat":45.73753
     },
     {
        "lng":-122.76076,
        "lat":45.74676
     },
     {
        "lng":-122.76093,
        "lat":45.74984
     },
     {
        "lng":-122.76093,
        "lat":45.74997
     },
     {
        "lng":-122.76096,
        "lat":45.75038
     },
     {
        "lng":-122.76096,
        "lat":45.75051
     },
     {
        "lng":-122.7613,
        "lat":45.75657
     },
     {
        "lng":-122.76145,
        "lat":45.75916
     },
     {
        "lng":-122.764,
        "lat":45.76585
     },
     {
        "lng":-122.67509102783202,
        "lat":45.7903020039659
     },
     {
        "lng":-122.48454689941406,
        "lat":45.771386645649436
     },
     {
        "lng":-122.38017678222656,
        "lat":45.62943694303993
     },
     {
        "lng":-122.40077614746093,
        "lat":45.587166180900134
     },
     {
        "lng":-122.41071,
        "lat":45.56763
     }
  ];
  areaClark: Array<any> = [
    {lng: -122.41071, lat: 45.56763},
    {lng: -122.43867, lat: 45.56358},
    {lng: -122.4546, lat: 45.56772},
    {lng: -122.45955, lat: 45.57042},
    {lng: -122.47349, lat: 45.57771},
    {lng: -122.48139, lat: 45.5803},
    {lng: -122.49226, lat: 45.58328},
    {lng: -122.50421, lat: 45.5858},
    {lng: -122.54588, lat: 45.59619},
    {lng: -122.55032, lat: 45.59727},
    {lng: -122.58313, lat: 45.60424},
    {lng: -122.60771, lat: 45.60814},
    {lng: -122.67504, lat: 45.61804},
    {lng: -122.69101, lat: 45.62474},
    {lng: -122.70274, lat: 45.63142},
    {lng: -122.74451, lat: 45.64734},
    {lng: -122.76381, lat: 45.65714},
    {lng: -122.76975, lat: 45.70762},
    {lng: -122.76261, lat: 45.72824},
    {lng: -122.76211, lat: 45.72948},
    {lng: -122.7606, lat: 45.7332},
    {lng: -122.76011, lat: 45.73441},
    {lng: -122.76011, lat: 45.73445},
    {lng: -122.76028, lat: 45.73753},
    {lng: -122.76076, lat: 45.74676},
    {lng: -122.76093, lat: 45.74984},
    {lng: -122.76093, lat: 45.74997},
    {lng: -122.76096, lat: 45.75038},
    {lng: -122.76096, lat: 45.75051},
    {lng: -122.7613, lat: 45.75657},
    {lng: -122.76145, lat: 45.75916},
    {lng: -122.764, lat: 45.76585},
    {lng: -122.67509102783202, lat: 45.7903020039659},
    {lng: -122.48454689941406, lat: 45.771386645649436},
    {lng: -122.38017678222656, lat: 45.62943694303993},
    {lng: -122.40077614746093, lat: 45.587166180900134}
  ];
  isShowing;


  constructor(private databaseService: DatabaseService) { }

  ngOnInit() {

    // console.log(this.databaseService.getArea())
    this.databaseService.getEntries().subscribe( result => {
      for (const entry of result) {
        const client = entry.client;
        if (this.entryClients.indexOf(client) === -1) {
          this.entryClients.push(client);
          this.entries.push(entry);
        } else {
          const index = this.entryClients.indexOf(client);
          this.entries[index].moles = parseInt(this.entries[index].moles, 10) + parseInt(entry.moles, 10);
        }
      }
    });
  }

  show(i) {
    this.isShowing = i;
    console.log(i)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/map/map.component.ts